module.exports = __webpack_public_path__ + "c305a828efdfe8d0e57a840028d3c289.ttf";